import { openDB } from 'idb';
import { LocalStorage } from 'quasar';

let dbPromise = null;
const DB_NAME = 'localCart';
const STORE_NAME = 'cart_items';

if (process.env.CLIENT) {
    dbPromise = openDB(DB_NAME, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'id' });
            }
        },
    });
}


const cartDB = {
    async addItem(item) {
        const serializableData = JSON.parse(JSON.stringify(item));
        let id = LocalStorage.getItem('tokenDb') || Date.now();
        serializableData.id = id;
        const db = await dbPromise;
        return db.put(STORE_NAME, serializableData);
    },
    async getItem(id) {
        const db = await dbPromise;
        return db.get(STORE_NAME, id);
    },
    async updateItem(store) {
        try {
            const serializableData = JSON.parse(JSON.stringify(store));
            let id = LocalStorage.getItem('tokenDb') || Date.now();
            serializableData.id = id;
            const db = await dbPromise;
            return db.put(STORE_NAME, serializableData);
        } catch (error) {
            console.error('Ошибка при обновлении элемента:', error);
        }
    },
    async setCheckAllItems(checked) {
        try {
            let idDb = LocalStorage.getItem('tokenDb') || Date.now();
            const db = await dbPromise;
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const storedData = await store.get(idDb);
            if (storedData) {
                storedData.localData.products.forEach((product) => {
                    product.checked = checked;
                });
            }
            await store.put(storedData);
        } catch (error) {
            console.error('Ошибка при обновлении элемента:', error);
        }
    },
    async updateFavourite(id, check) {
        try {
            let idDb = LocalStorage.getItem('tokenDb') || Date.now();
            const db = await dbPromise;
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            // Получаем объект по ключу
            const storedData = await store.get(idDb);

            if (storedData) {
                if (check) {
                    storedData.localData.favourites.push(id);
                } else {
                    storedData.localData.favourites = storedData.localData.favourites.filter((item) => item !== id);
                }
            }
            await store.put(storedData);
        } catch (error) {
            console.error('Ошибка при обновлении элемента:', error);
        }
    },


    async deleteCheckItems(products) {
        try {
            let idDb = LocalStorage.getItem('tokenDb') || Date.now();
            const db = await dbPromise;
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const storedData = await store.get(idDb);
            if (storedData) {
                products.forEach((product) => {
                    const idx = storedData.localData.products.findIndex((elem) => elem.id === product.id);
                    if (idx !== -1) { // Проверяем, что индекс найден
                        storedData.localData.products.splice(idx, 1);
                    }
                });
            }
            await store.put(storedData);
        } catch (error) {
            console.error('Ошибка при обновлении элемента:', error);
        }
    },

    async clearCart() {
        try {
            let idDb = LocalStorage.getItem('tokenDb') || Date.now();
            const db = await dbPromise;
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const storedData = await store.get(idDb);
            if (storedData) {
                storedData.localData = {
                    drugstoreId: [],
                    favourites: [],
                    products: [],
                };
            }
            await store.put(storedData);
        } catch (error) {
            console.error('Ошибка при обновлении элемента:', error);
        }
    },
};
export { cartDB, dbPromise };
